<template>
  <div class="list-container">
    <entity-filter :title="title" v-show="!showAdvancedFilter" :data-list="reports"
    :searchable-fields="searchableFields" show-alphabetized-filter="false"
    :use-group="true" :group-by-options="groupByOptions"
    :actions="actions"
    >
    </entity-filter>
    <generic-table v-show="!showAdvancedFilter" :title-map="titleMap" :table-body="reports" :end-point="endPoint"></generic-table>
  </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import { bus } from '../../main';
import EntityFilter from '../EntityFilter';
import GenericTable from '../GenericTable';
import TestGenericTable from '../TestGenericTable';
import store from '../../store.js';

export default {
  data() {
    return {
      initialize: null,
      title: {'icon': 'icon-report', 'name': "Reports"},
      titleMap: {
        'name': 'Name',
        'mea': 'MEA',
        'indicator': 'Indicator',
        'description': 'Description',
        'category': 'Category',
      },
      groupByOptions: {
        'name': 'Name',
        'mea': 'MEA',
        'indicator': 'Indicator',
        'description': 'Description',
        'category': 'Category',
      },
      endPoint: 'reports/{{ id }}/details',
      searchableFields: ['name'],
      label: 'Loading',
      actions: [
        {
          name: 'Create Report',
          url: "/reports/create",
          perm: "add_report"
        }
      ]
    };
  },
  
  methods: {
    toggleSidebar(){
      bus.$emit('toggle-sidebar');
    },
  },
  
  computed:{
    ...mapState({
      showAdvancedFilter: state => state.showAdvancedFilter,
      loading: state => state.loading,
    }),
    
    reports: () => {
      let reports = store.state.reports;
      let reportFilter = store.state.reportFilter;
            
      if (reportFilter) {
        let selectedIndicator = store.state.selectedIndicator;
    
        if (reports !== null) {
          if (Object.keys(selectedIndicator).length > 0) 
            return reports.filter((report) => report.indicator == selectedIndicator.name);     
        }
      }
      
      return reports;
    },
  },
  
  beforeRouteEnter (to, from, next) {
    let id = to.params.id;
    store.state.previousPath = from;
    store.dispatch('fetchReports');
    next();
  },
  
  mounted() {    
    if (store.state.previousPath !== null) {
      if(store.state.previousPath.name != 'front-page') this.toggleSidebar();
      store.state.previousPath = null;
    }
  },
  
  beforeDestroy () {
    if (Object.keys(store.state.selectedIndicator).length > 0) 
      store.state.selectedIndicator = {};
    store.state.reportFilter = false;
  },
  
  components:{
    GenericTable,
    TestGenericTable,
    EntityFilter,
  }
};
</script>
<style lang="scss">
h1{
    height: 21px;
  }
.list-container{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/report/ReportList.vue